import { IPaginatedResourceEndpointResponse } from '@api/interfaces';
import { ManageScoreSubmission } from '@api/competitionsApi/interfaces';
import { QueryClient } from '@tanstack/react-query';

export const removeSubmissionFromManageSubmissionsCache = (
  queryClient: QueryClient,
  slug: string,
  submissionId: number
): void => {
  queryClient.setQueriesData<
    IPaginatedResourceEndpointResponse<ManageScoreSubmission>
  >({ queryKey: ['mng-competition-submissions', slug] }, (old) => {
    if (!old) {
      return old;
    }

    const hadSubmission = old.data.some(
      (submission) => submission.id === submissionId
    );

    if (!hadSubmission) {
      return old;
    }

    return {
      ...old,
      data: old.data.filter((submission) => submission.id !== submissionId),
      meta: {
        ...old.meta,
        total: Math.max(0, old.meta.total - 1),
      },
    };
  });
};
